// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"68e4e297","243":"85ed312f"}[chunkId] + ".chunk.js";
};